import {httpService} from "@/services/HttpService";

export function validateHorseUeln(ueln?: string, ref?: string): Promise<boolean> {
    if (ref) {
        return httpService.get(`/horse/validate-ueln?ueln=${ueln}&horseRef=${ref}`)
    } else {
        return httpService.get(`/horse/validate-ueln?ueln=${ueln}`)
    }
}